import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.SaldosUsuariosZEViewDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Proveedor", cell: x => ({ data: x.NombreUsuarioZE }) },
    { title: "Fecha", cell: x => ({ data: kea.formatDate(x.Fecha) }) },
    { title: "Importe", cell: x => ({ data: kea.formatCurrency(x.Importe) }) },
    { title: "Saldo", cell: x => ({ data: kea.formatCurrency(x.Saldo) }) },
    { title: "TipoOrigen", cell: x => ({ data: models.OrigenMovimientoSaldoUsuarioZE[x.TipoOrigen] }) },
    { title: "Usuario Capturo", cell: x => ({ data: x.UsuarioCapturo }) },

];

/**Obtiene las columnas del grid */
export function columnas(): Column[] {
    return [...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/actividadesusuariosze/list/columns.tsx